module.exports = __webpack_public_path__ + "static/media/Ppshp_kokonimi-L600.4348efad.jpg";